import type { UseQueryResult } from "react-query";
import type UserPreferences from "../types/UserPreferences";

/** True when this build is running against a production Patient Embed host (not local/QA/staging). */
export const isPatientEmbedProductionHost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const hostname = window.location.hostname;
  if (
    hostname.includes("localhost") ||
    hostname.includes("127.0.0.1") ||
    hostname.includes("qa-app") ||
    hostname.includes("staging")
  ) {
    return false;
  }
  return true;
};

export const isInternalQventusUsername = (
  username: string | null | undefined
): boolean => Boolean(username && username.toLowerCase().includes("qventus"));

/**
 * Internal Qventus users on production cannot change patient data unless `prod_edit` is set on their
 * UserPreferences (via Django admin). Until preferences load, we use `emr_user_id` from the URL when present.
 */
export const computeProductionDataReadOnly = (
  userPreferencesQuery: Pick<
    UseQueryResult<UserPreferences>,
    "isSuccess" | "data"
  >
): boolean => {
  if (!isPatientEmbedProductionHost()) return false;
  const urlEmr =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("emr_user_id") || ""
      : "";
  if (!userPreferencesQuery.isSuccess) {
    return isInternalQventusUsername(urlEmr);
  }

  if (!userPreferencesQuery.data) return false;

  const up = userPreferencesQuery.data[0];
  if (!isInternalQventusUsername(up.emr_user_id)) return false;
  return !up.prod_edit;
};
